import React, { useState } from "react";
import AdminToast from "../../../core/admin/adminToast";
import { useAuth } from "../../../../context/authProvider";
import InstagramIcon from "../../../../img/svg/instagramIcon";
import { getAbsoluteUrl } from "../../../../utils/functions";
import WhatsappIcon from "../../../../img/svg/whatsappIcon";
import { Link } from "react-router-dom";
import AdminPage from "../../../core/admin/adminPage";
import AdminCard from "../../../core/admin/adminCard";
import AdminButton from "../../../core/admin/adminButton";
import AdminField, { AdminTextarea } from "../../../core/admin/adminField";
import AdminTextInput from "../../../core/admin/adminTextInput";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { ExternalLinkIcon, GlobeIcon, LockIcon, PencilIcon } from "../../../../img/svg/adminIcons";

export default function MyContact() {

    const { user, updateUserContact } = useAuth();

    const [loading, setLoading] = useState(false);

    const [desc, setDesc] = useState(user?.description || "");
    const [editDesc, setEditDesc] = useState(false);

    const [insta, setInsta] = useState(user?.instagram || "");
    const [editInsta, setEditInsta] = useState(false);

    const [site, setSite] = useState(user?.site || "");
    const [editSite, setEditSite] = useState(false);

    const [goodToast, setGoodToast] = useState(false);
    const [badToast, setBadToast] = useState(false);

    const handleField = (setField: React.Dispatch<React.SetStateAction<string>>, value: string) => {
        if (value.length < 128) {
            setField(value);
        }
    }
    const handleDesc = (value: string) => {
        if (value.length < 236) {
            setDesc(value);
        }
    }

    const doEditDesc = async () => {
        setLoading(true);
        const updateAction = await updateUserContact("description", desc);
        if (!updateAction) {
            setLoading(false);
            setBadToast(true);
            return null;
        }
        setEditDesc(false);
        setLoading(false);
        setGoodToast(true);
    }

    const doEditInsta = async () => {
        setLoading(true);
        const updateAction = await updateUserContact("instagram", insta);
        if (!updateAction) {
            setLoading(false);
            setBadToast(true);
            return null;
        }
        setEditInsta(false);
        setLoading(false);
        setGoodToast(true);
    }

    const doEditSite = async () => {
        setLoading(true);
        
        const updateAction = await updateUserContact("site", handleLink(site));
        if (!updateAction) {
            setLoading(false);
            setBadToast(true);
            return null;
        }
        setEditSite(false);
        setLoading(false);
        setGoodToast(true);
    }

    const handleLink = (link: string) => {
        if(!link.includes("https://") && !link.includes("http://")){
            return "https://"+link;
        }
        return link;
    }

    return (
        <AdminPage
            title="Meu contato"
            description="Informações exibidas para os compradores na sua página de anunciante."
            actions={
                user?.slug ?
                    <a href={`/advertisers/${user?.slug}`} target="_blank" rel="noreferrer" className="inline-flex h-10 items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 text-sm font-semibold text-gray-800 hover:bg-gray-50">
                        Ver minha página <ExternalLinkIcon width="14px" />
                    </a>
                    : null
            }
        >
            {
                loading ?
                    <AdminCard><AdminLoading /></AdminCard>
                    :
                    <>
                        {
                            user?.cpf ?
                                <AdminCard bodyClassName="p-4 md:px-6">
                                    <div className="flex items-center gap-3">
                                        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-500"><LockIcon width="18px" /></span>
                                        <div>
                                            <p className="text-sm font-semibold text-gray-900">CPF: {user?.cpf}</p>
                                            <p className="text-xs text-gray-500">Informação não visível para outros usuários</p>
                                        </div>
                                    </div>
                                </AdminCard>
                                : null
                        }

                        {/* DESCRIÇÃO */}
                        <AdminCard
                            title="Descrição"
                            description={<>Esta descrição estará visível na sua <a href={`/advertisers/${user?.slug}`} target="_blank" rel="noreferrer" className="font-semibold text-gray-900 underline decoration-secondary underline-offset-2">página do anunciante</a>.</>}
                            actions={!editDesc ? <AdminButton size="sm" variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => setEditDesc(true)}>Alterar</AdminButton> : null}
                        >
                            <AdminField label="Texto" htmlFor="contact-desc" counter={editDesc ? { current: desc.length, max: 235 } : undefined}>
                                <AdminTextarea id="contact-desc" disabled={!editDesc} value={desc} onChange={e => handleDesc(e.target.value)} placeholder="Conte um pouco sobre você ou sua loja" />
                            </AdminField>
                            {
                                editDesc ?
                                    <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 mt-4">
                                        <AdminButton variant="secondary" onClick={() => setEditDesc(false)}>Cancelar</AdminButton>
                                        <AdminButton disabled={desc === user?.description} onClick={doEditDesc}>Salvar</AdminButton>
                                    </div>
                                    : null
                            }
                        </AdminCard>

                        {/* REDES */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            {/* INSTAGRAM */}
                            <ContactCard icon={<InstagramIcon fill="currentColor" width="22px" />} title="Instagram">
                                {
                                    editInsta ?
                                        <div className="flex flex-col gap-3">
                                            <div className="flex items-stretch overflow-hidden rounded-lg border border-gray-300 focus-within:border-gray-900 focus-within:ring-2 focus-within:ring-secondary/30">
                                                <span className="flex items-center bg-gray-50 px-2 text-xs text-gray-500 border-r border-gray-300">instagram.com/</span>
                                                <input disabled={!editInsta} className="min-w-0 flex-1 px-2 py-2 text-base md:text-sm outline-none" placeholder="Instagram" type="text" value={insta} onChange={e => handleField(setInsta, e.target.value)} />
                                            </div>
                                            <div className="flex gap-2">
                                                <AdminButton size="sm" variant="secondary" onClick={() => setEditInsta(false)} className="flex-1">Cancelar</AdminButton>
                                                <AdminButton size="sm" disabled={insta === user?.instagram} onClick={doEditInsta} className="flex-1">Salvar</AdminButton>
                                            </div>
                                        </div>
                                        :
                                        <div className="flex flex-col gap-3">
                                            {
                                                user?.instagram ?
                                                    <ContactLink href={`https://instagram.com/${user?.instagram}`}>{`https://instagram.com/${user?.instagram}`}</ContactLink>
                                                    : <p className="text-sm text-gray-400">Não informado</p>
                                            }
                                            <AdminButton size="sm" variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => setEditInsta(true)}>Alterar</AdminButton>
                                        </div>
                                }
                            </ContactCard>
                            {/* WHATSAPP */}
                            <ContactCard icon={<WhatsappIcon fill="currentColor" width="22px" />} title="WhatsApp">
                                <div className="flex flex-col gap-3">
                                    {
                                        user?.phoneNumber ?
                                            <ContactLink href={`https://wa.me/55${user?.phoneNumber}`}>{`https://wa.me/55${user?.phoneNumber}`}</ContactLink>
                                            : <p className="text-sm text-gray-400">Não informado</p>
                                    }
                                    <Link to="/me" className="inline-flex h-8 items-center justify-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 text-xs font-semibold text-gray-800 hover:bg-gray-50">
                                        <PencilIcon width="14px" /> Alterar na Minha Área
                                    </Link>
                                </div>
                            </ContactCard>
                            {/* SITE */}
                            <ContactCard icon={<GlobeIcon width="22px" />} title="Site">
                                {
                                    editSite ?
                                        <div className="flex flex-col gap-3">
                                            <AdminTextInput disabled={!editSite} inputMode="url" placeholder="Site" value={site} onChange={e => handleField(setSite, e.target.value)} />
                                            <div className="flex gap-2">
                                                <AdminButton size="sm" variant="secondary" onClick={() => setEditSite(false)} className="flex-1">Cancelar</AdminButton>
                                                <AdminButton size="sm" disabled={site === user?.site} onClick={doEditSite} className="flex-1">Salvar</AdminButton>
                                            </div>
                                        </div>
                                        :
                                        <div className="flex flex-col gap-3">
                                            {
                                                user?.site ?
                                                    <ContactLink href={getAbsoluteUrl(user.site)}>{getAbsoluteUrl(user.site)}</ContactLink>
                                                    : <p className="text-sm text-gray-400">Não informado</p>
                                            }
                                            <AdminButton size="sm" variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => setEditSite(true)}>Alterar</AdminButton>
                                        </div>
                                }
                            </ContactCard>
                        </div>
                    </>
            }
            <AdminToast toast={goodToast} setToast={setGoodToast} tone="success" message="Usuário atualizado!" />
            <AdminToast toast={badToast} setToast={setBadToast} tone="danger" message="Erro!" />
        </AdminPage>
    )
}

function ContactCard({ icon, title, children }: { icon: React.ReactNode, title: string, children: React.ReactNode }) {
    return (
        <section className="flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
            <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gray-900 text-white">{icon}</span>
                <h3 className="font-bold text-gray-900">{title}</h3>
            </div>
            {children}
        </section>
    )
}

function ContactLink({ href, children }: { href: string, children: React.ReactNode }) {
    return (
        <a href={href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-semibold text-gray-900 underline decoration-secondary underline-offset-2 break-all">
            {children}
        </a>
    )
}
